// extracted by mini-css-extract-plugin
export default {"container":"AttachmentThumbnail_container__xv-kw","sumText":"AttachmentThumbnail_sumText__AFFY4","final":"AttachmentThumbnail_final__887N4","btns":"AttachmentThumbnail_btns__OF22v"};